import { FormattedMessage } from 'react-intl';

import './inventoryDescription.scss';

import type { ReactNode } from 'react';

type Props = {
  type: 'generic' | 'specific';
};

const bold = (chunks: ReactNode) => <strong>{chunks}</strong>;

/** Per-tab description and, for the specific tab, an informative (non-dismissible) warning banner. */
export function InventoryDescription({ type }: Props) {
  return (
    <div className="inventoryDescription">
      <p className="inventoryDescription__text">
        {type === 'generic' ? (
          <FormattedMessage
            defaultMessage="<bold>Manage where your ads appear by including or excluding entire domains.</bold> Note: Targeting a domain (e.g., 'example.com') automatically applies to all its subdomains and pages."
            id="appAndSiteMarketplace.inventory.description.generic"
            values={{ bold }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="<bold>Target specific web properties and mobile apps.</bold> Enter Sonata IDs or App Bundles (iOS/Android) to load related inventory, then choose which ones to include or exclude."
            id="appAndSiteMarketplace.inventory.description.specific"
            values={{ bold }}
          />
        )}
      </p>
      {type === 'specific' && (
        <div className="inventoryDescription__warning" role="note">
          <i aria-hidden="true" className="fa-regular fa-circle-exclamation" />
          <span>
            <FormattedMessage
              defaultMessage={
                '<bold>This may take a few minutes.</bold> Adding elements via "specific URLs" takes a bit longer. Feel free to keep working on other tasks while it loads in the background.'
              }
              id="appAndSiteMarketplace.inventory.specificWarning"
              values={{ bold }}
            />
          </span>
        </div>
      )}
    </div>
  );
}
